import { useEffect } from 'react';
import WistiaUtils from 'edrolo/utils/WistiaUtils';
import preloadImage from 'edrolo/utils/preloadImage';
import debugLog from 'core/utils/debugLog';

import EPT from 'edrolo/propTypes';

const WistiaPreloader = ({ video }) => {
  const videoHash = video.get('wistia_hashed_id');
  const key = `${videoHash}_preload`;
  useEffect(() => {
    // componentDidMount hook equivalent
    const thumbnail = WistiaUtils.getThumbnail(video);
    debugLog('preloading thumbnail', thumbnail);
    preloadImage(thumbnail);

    return () => {
      // componentDidUnmount hook equivalent
      const video = global.Wistia?.api(key);
      if (video) {
        video.remove();
      }
    };
  });

  if (!videoHash) {
    return null;
  }

  debugLog('rendering preload embed', videoHash);
  return (
    <div style={{ height: 0 }}>
      <div
        id={key}
        key={key}
        className={`wistia_embed wistia_async_${videoHash} autoPlay=false preload=true`}
      >
        &nbsp;
      </div>
    </div>
  );
};

WistiaPreloader.propTypes = {
  video: EPT.WistiaVideo.isRequired,
};

export default WistiaPreloader;
